import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
// To get Slider Menu from Right Side :
import MobilRightMenuSlider from "@material-ui/core/Drawer";
import Footer from "./Footer";
// To Get the Menu Icon 
import MenuIcon from '@material-ui/icons/Menu';
// Readymade components are imported from Material UI :
import {
  AppBar,
  Toolbar,
  ListItem,
  ListItemIcon,
  IconButton,
  ListItemText,
  Avatar,
  Divider,
  List,
  Typography,
  Box,
} from "@material-ui/core";
// Import Icons
import {
  AssignmentInd,
  Home,
  Apps,
  ContactMail,
} from "@material-ui/icons";
import avatar from "../avatar.png";

// CSS STYLES
const useStyles = makeStyles((theme) => ({
  menuSliderContainer: {
    width: 250,
    background: "#e67410",
    height: "100%",
  },
  mainContainer: {
    background: "#233"
  },
  avatar: {
    display: "block",
    margin: "0.5rem auto",
    width: theme.spacing(14),
    height: theme.spacing(14),
    
  },
  listItem: {
    color: "white",
  },
}));

const menuItems = [
  {
    listIcon: <Home />,
    listText: "Home",
    listPath: "/",
  },
  {
    listIcon: <AssignmentInd />,
    listText: "Resume",
    listPath: "/resume",
  },
  {
    listIcon: <Apps />,
    listText: "Portfolio",
    listPath: "/portfolio",
  },
  {
    listIcon: <ContactMail />,
    listText: "Contact",
    listPath: "/contact",
  },
];

const Navbar = () => {
  // Variable For Conditional Rendering 
  const [state, setState] = useState({right: false});

  const toggleSlider = (slider, open) => () => {
    setState({ ...state, [slider]: open });
  };

  const classes = useStyles();

  // Function Which Controls Whole Of The Right Sidebar
  const sideList = (slider) => (
    /* The Box component serves as a wrapper component for most of the CSS utility needs. */
    <Box
      className={classes.menuSliderContainer}
      component="div"
      onClick={toggleSlider(slider, false)}
    >
      {/* Displaying Avatar */}
      <Avatar className={classes.avatar} src={avatar} alt="Ankit Rana" />
      { /* It is similar to </hr> */ }
      <Divider />
      {/* List to display items in toggle sidebar */}
      <List>
        {/* Using a map to traverse through each component */}
        {menuItems.map((lsItem, key) => (
          <ListItem button key={key} component={Link} to={lsItem.listPath}>
            <ListItemIcon className={classes.listItem}>
              {lsItem.listIcon}
            </ListItemIcon>
            <ListItemText
              className={classes.listItem}
              primary={lsItem.listText}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
  return (
    <>
      <Box id="navBar" component="nav" className={classes.mainContainer}>
        <AppBar position="fixed" style={{ background: "#222" }}>
          <Toolbar>
            {/* Icon Which Handles Opening Of Sidebar on Click */}
            <IconButton edge="start" onClick={toggleSlider("right", true)}>
              <MenuIcon style={{ color: "#e67410" }} />
            </IconButton>
            <Typography variant="h5" style={{ color: "#e67410" }}>
              {/* Nav Bar Brand */}
              <Link to="/" style={{ color: "#e67410", textDecoration: "none" }}>
                Ankit Rana
              </Link>
            </Typography>
            {/* This Will Enable Opening Slider From Right Side */}
            <MobilRightMenuSlider
              anchor="right"
              open={state.right}
              onClose={toggleSlider("right", false)}
            >
              {/* Calling Right Side */}
              {sideList("right")}
              <Footer />
            </MobilRightMenuSlider>
          </Toolbar>
        </AppBar>
      </Box>
    </>
  );
};

Navbar.propTypes = {
  state: PropTypes.object,
};

export default Navbar;
